const topics = [
  { name: '韩漫推荐', icon: 'ri-heart-line', heat: '2.3万讨论', color: 'primary' },
  { name: '日漫经典', icon: 'ri-sun-line', heat: '1.8万讨论', color: 'accent' },
  { name: '国漫崛起', icon: 'ri-flag-line', heat: '1.5万讨论', color: 'secondary' },
  { name: '恋爱漫画', icon: 'ri-heart-pulse-line', heat: '1.2万讨论', color: 'primary' },
  { name: '热血战斗', icon: 'ri-flashlight-line', heat: '9800讨论', color: 'accent' },
  { name: '悬疑推理', icon: 'ri-search-eye-line', heat: '8600讨论', color: 'secondary' },
  { name: '搞笑日常', icon: 'ri-emotion-laugh-line', heat: '7900讨论', color: 'primary' },
  { name: '新番速递', icon: 'ri-rocket-line', heat: '7200讨论', color: 'accent' },
  { name: '收藏夹分享', icon: 'ri-bookmark-line', heat: '6500讨论', color: 'secondary' },
];

const colorMap: Record<string, { bg: string; text: string; iconBg: string }> = {
  primary: { bg: 'bg-primary-50 hover:bg-primary-100', text: 'text-primary-700', iconBg: 'bg-primary-100 text-primary-600' },
  accent: { bg: 'bg-accent-50 hover:bg-accent-100', text: 'text-accent-700', iconBg: 'bg-accent-100 text-accent-600' },
  secondary: { bg: 'bg-secondary-50 hover:bg-secondary-100', text: 'text-secondary-700', iconBg: 'bg-secondary-100 text-secondary-600' },
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            热门话题
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            大家都在讨论什么
          </h2>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3">
          {topics.map((topic, i) => {
            const c = colorMap[topic.color];
            return (
              <div
                key={i}
                className={`flex items-center gap-3 px-4 py-3.5 rounded-xl border border-background-200/60 ${c.bg} transition-colors cursor-pointer`}
              >
                <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${c.iconBg}`}>
                  <i className={`${topic.icon} text-base`}></i>
                </div>
                <div className="min-w-0">
                  <div className={`text-sm font-semibold ${c.text} truncate`}>{topic.name}</div>
                  <div className="text-xs text-foreground-500">{topic.heat}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}